import apiClient from '@/repositories/apiClient';
import { api } from './api';

export const elementsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getElements: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "elements",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result?.data ?
          [ ...result.data.map(({ model}) => ({ type: 'Elements', id: model.ID })),
            { type: 'Elements', id: 'LIST' },
          ]
          :
          [{ type: 'Elements', id: 'LIST' }]

      }
    }),
    getElementHighlights: build.query({
      // Aggregated tile mode: the backend collapses pairs into one tile
      // and emits one tile per variant group so the panel's visible 9
      // slots are budgeted on tiles, not on raw media rows. Response
      // shape is `{tiles: [{kind: "media"|"variant_group", ...}]}`
      // instead of `{data: [media]}` — see ElementsHighlight.js for the
      // rendering branch.
      query: () => ({
        url: "elements",
        method: "POST",
        body: JSON.stringify({
          skip: 0,
          limit: 9,
          filter: { highlighted: 1, aggregated: true },
        }),
      }),
      providesTags: (result) => {
        return result?.tiles
          ? [
            ...result.tiles
              .filter((t) => t.kind === 'media')
              .map((t) => ({ type: 'Elements', id: t.media?.model?.ID })),
            ...result.tiles
              .filter((t) => t.kind === 'variant_group')
              .map((t) => ({ type: 'VariantGroups', id: t.variant_group?.model?.ID })),
            { type: 'Elements', id: 'HIGHLIGHTED' },
          ]
          : [{ type: 'Elements', id: 'HIGHLIGHTED' }];
      },
    }),
    getNewestElements: build.query({
      // Aggregated tile mode, but no `newest: 1` flag — that flag means
      // "not yet viewed by this organisation" on the server and is
      // tripped by a single click on the element form (setAsViewed),
      // dropping freshly uploaded elements out of the panel as soon as
      // the operator opens them. The panel's promise is "vor kurzem
      // erst hochgeladen", which the server's default
      // (highlighted DESC, created_at DESC) order delivers without any
      // additional filter.
      query: () => ({
        url: "elements",
        method: "POST",
        body: JSON.stringify({
          skip: 0,
          limit: 9,
          filter: { aggregated: true },
        }),
      }),
      providesTags: (result) => {
        return result?.tiles
          ? [
            ...result.tiles
              .filter((t) => t.kind === 'media')
              .map((t) => ({ type: 'Elements', id: t.media?.model?.ID })),
            ...result.tiles
              .filter((t) => t.kind === 'variant_group')
              .map((t) => ({ type: 'VariantGroups', id: t.variant_group?.model?.ID })),
            { type: 'Elements', id: 'NEWEST' },
          ]
          : [{ type: 'Elements', id: 'NEWEST' }];
      },
    }),
    assignElementsToGroups: build.mutation({
      // `variantGroupIds` is optional. When supplied, the backend expands
      // each variant-group into its member-media ids and applies the same
      // group-assignment to all of them — so the bulk modal can mix
      // standalone media tiles and variant-group tiles in one operation.
      query: ({ ids, variantGroupIds = [], groups, preSelectedGroups }) => ({
        url: 'elements/groups',
        method: 'POST',
        body: JSON.stringify({
          ids,
          variant_group_ids: variantGroupIds,
          groups,
          preSelectedGroups,
        }),
      }),
      invalidatesTags: (result, _error, arg) => {
        const tags = (result?.elements || []).map((el) => ({ type: 'Elements', id: el }));
        // If the bulk action touched variant groups, also invalidate them so
        // the gallery's group tiles and any open VariantGroupForm refetch.
        if ((arg?.variantGroupIds || []).length > 0) {
          tags.push({ type: 'VariantGroups', id: 'LIST' });
          for (const vgId of arg.variantGroupIds) {
            tags.push({ type: 'VariantGroups', id: vgId });
          }
        }
        return tags;
      },
    }),
  }),
});

export const get_statistics = async () => {
  try {
    let data = await apiClient.get('/element/get_statistics');
    return data;
  } catch {
    // fehler
    return false;
  }
}

export const {
  useGetElementsQuery,
  useGetElementHighlightsQuery,
  useGetNewestElementsQuery,
  useAssignElementsToGroupsMutation,
} = elementsApi;
